// deno-coverage-ignore-start - parsebox tested
import { IsArray, IsEqual } from './guard.mjs';
/** Checks the value is a Tuple-2 [string, string] result */
export function IsResult(value) {
    return IsArray(value) && IsEqual(value.length, 2);
}
// deno-coverage-ignore-stop
